var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"timer-container"},[_c('p',{staticStyle:{"color":"#333639"}},[_vm._v("\n    "+_vm._s(`Reativar (${_vm.minutes}min ${_vm.seconds <= 10 ? '0' + _vm.seconds + 's' : _vm.seconds + 's'}).`)+"\n  ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }